const e=(t={})=>t;export{e as createMentionData};
//# sourceMappingURL=createMentionData.js.map
